/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  $(function(){
        
        //mega menu image hover
        $('.mega_link a').each(function(){
          
          $(this).mouseover(function(){
            $(this).parents('.MegaMenu__Inner').find('.mega_image').hide();
            var collection_tag = $(this).attr('id');
            collection_tag = "."+collection_tag;
            $(collection_tag).show();
          });

        });
        
        //open external links in new tab
        
        var links = document.links;
        for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
          if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].relList.add('noreferrer', 'noopener');
          }
        }
        
        //size guide popup
        $('.Popup_inner').hide();
        
        $('.popup_button').click(function(e){
          e.preventDefault();
          e.stopPropagation();
          $('.Popup_inner').show();
          $('body').addClass('popup-open');
        });
        
        $('#close-x').click(function(e){
          e.preventDefault();
          e.stopPropagation();
          $('.Popup_inner').hide();
          $('body').removeClass('popup-open');
        })
        
        
        //collection nav active style
        var collection_url = window.location.pathname;
        $('.collection_nav a').each(function(){
        
          if($(this).attr('href') == collection_url){
           $(this).addClass('active');
          }

        });
        
      });


$(function(){
  if(typeof product_variants_disabled !== 'undefined'){
    
    if($('.ColorSwatchList').length > 0){
     multi_variant_disabled();
      
      $('.ColorSwatch').click(function(){
        setTimeout(function(){ multi_variant_disabled()}, 300);
      });
 
    } else{
     $('.SizeSwatchList li').each(function(){
       var variant_val = $(this).find('.SizeSwatch').html();
       
        for(i=0; i<product_variants_disabled.length; i++){

          var product_variant_disabled_clean = product_variants_disabled[i];
         product_variant_disabled_clean = product_variant_disabled_clean.replace(/\s/g, '');
          product_variant_disabled_clean = product_variant_disabled_clean.split('/');
         

        if(product_variant_disabled_clean.length == 1 && product_variant_disabled_clean.includes(variant_val)){
          $(this).find('.SizeSwatch').addClass('disabled');
        }


        }
      });
      
    }
  }
  
  function multi_variant_disabled(){
    
	var color_swatch = $('.ColorSwatch__Radio:checked').val();
    $('.SizeSwatch').removeClass('disabled');
    
    $('.SizeSwatchList li').each(function(){
       var variant_val = $(this).find('.SizeSwatch').html();
        for(i=0; i<product_variants_disabled.length; i++){

          var product_variant_disabled_clean = product_variants_disabled[i];
          
          product_variant_disabled_clean = product_variant_disabled_clean.split('/');
     
           for (var j = 0; j < product_variant_disabled_clean.length; j++) {
               product_variant_disabled_clean[j] = product_variant_disabled_clean[j].trim()
           }
          /*console.log(product_variant_disabled_clean);*/

        if(product_variant_disabled_clean.includes(variant_val) && product_variant_disabled_clean.includes(color_swatch)){
          $(this).find('.SizeSwatch').addClass('disabled');
        }


        }
      });
      
  }

});

$(function(){
   //waitlist guide popup
        $('.Waitlist_inner').hide();
        
        $('.waitlist_button').click(function(e){
          e.preventDefault();
          e.stopPropagation();
          $('.Waitlist_inner').show();
          $('body').addClass('popup-open');
        });
        
        $('#close-x-w').click(function(e){
          e.preventDefault();
          e.stopPropagation();
          $('.Waitlist_inner').hide();
          $('body').removeClass('popup-open');
        })
        
});

//smooth scroll
  $(function () {
    scrollToURLAnchor();
    
    function scrollToURLAnchor(){
       setTimeout(function(){
         if(window.location.hash){

           $('html, body').animate({
               scrollTop: $(window.location.hash).offset().top-100
           }, 200,  function () {

           });
         }
         }, 700);
    }


    $('a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html, body").animate(
            {
              scrollTop: target.offset().top - 100,
            },
            500
          );
          window.location.hash = this.hash;
          return false;
        }
      }
    });
  });

//* Precheck Gift Checkbox */
$(function(){
  $("#shopify-section-product-subscribe-gift .bold-ro__prepaid-gift-checkbox").prop('checked', true);
  setTimeout(function(){
	$("#shopify-section-product-subscribe-gift .bold-ro__prepaid-gift-checkbox").prop('checked', true)
  }, 2000);
});



/* Redirect /collections page */
if(window.location.pathname == "/collections"){
  window.location.pathname = '/collections/all'; 
}